import React from 'react';
/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from '@emotion/core';

import { Sizes } from 'src/design-system/style-types';

import { Text } from '../Text';
import { style } from './ProgressBar.style';

interface Props {
  size?: Sizes;
  percentageComplete?: number;
}

export const ProgressBar = ({ size = 'md', percentageComplete = 0 }: Props) => (
  <div css={style.progressBar({ size })}>
    <div css={style.filler({ percentageComplete })}>
      {size !== 'xs' && size !== 'sm' && <Text size={size}>{percentageComplete}%</Text>}
    </div>
  </div>
);
